(function () {
  var POP_OPEN_MS = 620;
  var POP_CLOSE_MS = 680;

  function stickyRoot(el) {
    return el && el.closest && el.closest('[data-sticky-atc]');
  }

  function getParts(rootEl) {
    return {
      root: rootEl,
      panel: rootEl.querySelector('[data-sticky-atc-panel]'),
      toggle: rootEl.querySelector('[data-sticky-atc-toggle]'),
    };
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setOpen(parts, open) {
    if (!parts.root) return;
    var shell = parts.root.querySelector('[data-sticky-atc-pop-shell]');
    var reduced = prefersReducedMotion();

    if (open) {
      if (parts.panel) parts.panel.removeAttribute('hidden');
      parts.root.classList.remove('sitcky-ATC--pop-overflow');
      parts.root.classList.add('sitcky-ATC--open');
      if (reduced || !shell) {
        parts.root.classList.add('sitcky-ATC--pop-overflow');
      } else {
        var onOpenEnd = function (e) {
          if (e.target !== shell || e.propertyName !== 'max-height') return;
          shell.removeEventListener('transitionend', onOpenEnd);
          parts.root.classList.add('sitcky-ATC--pop-overflow');
        };
        shell.addEventListener('transitionend', onOpenEnd);
        window.setTimeout(function () {
          shell.removeEventListener('transitionend', onOpenEnd);
          if (parts.root.classList.contains('sitcky-ATC--open')) {
            parts.root.classList.add('sitcky-ATC--pop-overflow');
          }
        }, POP_OPEN_MS);
      }
    } else {
      parts.root.classList.remove('sitcky-ATC--pop-overflow');
      window.requestAnimationFrame(function () {
        parts.root.classList.remove('sitcky-ATC--open');
        if (reduced || !shell) {
          if (parts.panel) parts.panel.setAttribute('hidden', '');
          return;
        }
        var onCloseEnd = function (e) {
          if (e.target !== shell || e.propertyName !== 'max-height') return;
          shell.removeEventListener('transitionend', onCloseEnd);
          if (parts.panel) parts.panel.setAttribute('hidden', '');
        };
        shell.addEventListener('transitionend', onCloseEnd);
        window.setTimeout(function () {
          shell.removeEventListener('transitionend', onCloseEnd);
          if (parts.panel) parts.panel.setAttribute('hidden', '');
        }, POP_CLOSE_MS);
      });
    }

    if (shell) shell.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (parts.toggle) {
      parts.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var openLabel = parts.toggle.getAttribute('data-sticky-atc-aria-open');
      var closeLabel = parts.toggle.getAttribute('data-sticky-atc-aria-close');
      if (openLabel && closeLabel) {
        parts.toggle.setAttribute('aria-label', open ? closeLabel : openLabel);
      }
    }

    if (open) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var shellOpen = parts.root && parts.root.querySelector('[data-sticky-atc-pop-shell]');
          if (shellOpen) {
            shellOpen.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        });
      });
    }
  }

  function closeAll() {
    document.querySelectorAll('[data-sticky-atc].sitcky-ATC--open').forEach(function (rootEl) {
      setOpen(getParts(rootEl), false);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var toggleBtn = t.closest && t.closest('[data-sticky-atc-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      var rootEl = stickyRoot(toggleBtn);
      if (!rootEl) return;
      var parts = getParts(rootEl);
      var willOpen = !rootEl.classList.contains('sitcky-ATC--open');
      if (willOpen) closeAll();
      setOpen(parts, willOpen);
      return;
    }

    if (t.closest && t.closest('[data-sticky-atc-close]')) {
      var rootElClose = stickyRoot(t);
      if (rootElClose) setOpen(getParts(rootElClose), false);
      return;
    }

    if (t.closest && t.closest('[data-sticky-atc]')) return;

    if (
      t.closest &&
      (t.closest('xo-popover') ||
        t.closest('xo-popover-trigger') ||
        t.closest('.xo-field-select-custom__popover'))
    ) {
      return;
    }

    closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAll();
  });
})();
